import React from "react";
import { Description } from "./Description";

export const Academic = ({ academic }) => {
  return (
    <section className="academic-experience section" id="education">
      <h2 className="section-title">Education</h2>
      <div className="timeline">
        {academic.map((academy) => (
          <Academy key={`${academy.institution}-${academy.career}`} {...academy} />
        ))}
      </div>
    </section>
  );
};

const Academy = ({ career, date, institution, degree, description = [] }) => {
  return (
    <article className="timeline-item card">
      <div className="timeline-header">
        <span className="timeline-pill">{date}</span>
        {degree && <span className="timeline-subtitle">{degree}</span>}
      </div>
      <h3 className="timeline-title">{career}</h3>
      <p className="timeline-meta">{institution}</p>
      {description.length > 0 && (
        <ul className="timeline-list">
          {description.map((desc, index) => (
            <Description key={index} desc={desc} />
          ))}
        </ul>
      )}
    </article>
  );
};